/**
 * Sprint P32 · Collar labels layer — HTML overlay anchored in local scene space.
 */
import { Html } from "@react-three/drei";
import { worldToScene, isValidCoordinate, pointInBox } from "@/lib/sceneCoords";


export function CollarLabels({
  holes, showLabels, origin, verticalExaggeration,
  activeBBox, includeOutliers = true,
}) {
  if (!showLabels || !holes?.length || !origin) return null;
  return (
    <group name="collar-labels"
           userData={{ coordinateSpace: "local_scene", layer: "labels" }}>
      {holes.map((h) => {
        if (!isValidCoordinate(h.x[0], h.y[0], h.z[0])) return null;
        const p = worldToScene(h.x[0], h.y[0], h.z[0], origin, verticalExaggeration);
        if (activeBBox && !includeOutliers && !pointInBox(p, activeBBox)) return null;
        return (
          <Html key={`lbl-${h.hole_id}`}
                position={[p.x, p.y + 8, p.z]}
                center style={{ pointerEvents: "none" }}>
            <div className="text-[9px] font-mono text-slate-800 bg-white/90 border border-slate-300 rounded px-1 py-0.5 whitespace-nowrap shadow">
              {h.hole_id}
            </div>
          </Html>
        );
      })}
    </group>
  );
}
